import moment from "moment-timezone";
import {formatHours, formatSecondsAsHours} from "@/utils/hourFormat";

export default {

    methods: {
        dateFormat(val, timezone = null) {
            if (val) {
                if (!timezone) {
                    return moment(val * 1000).format('DD/MM/YYYY');
                }
                return moment(val * 1000).tz(timezone).format('DD/MM/YYYY');
            }
        },
        dateFormatWithoutYear(val, timezone = null) {
            if (val) {
                if (!timezone) {
                    return moment(val * 1000).format('DD/MM/YYYY').substring(0, 5);
                }
                return moment(val * 1000).tz(timezone).format('DD/MM/YYYY').substring(0, 5);
            }
        },
        dateHourFormat(val, timezone = null) {
            if (val) {
                if (!timezone) {
                    return moment(val * 1000).format('DD/MM/YY HH:mm:ss')
                }
                return moment(val * 1000).tz(timezone).format('DD/MM/YY HH:mm:ss')
            }
        },
        /**
         * Recebe um tempo em segundos e devolve no formato HH:MM
         *
         * **/
        getTimeFromSecondsMixin(val) {
            if (!val || val <= 0) {
                return "";
            }
            return new Date(val * 1000).toISOString().substr(11, 5)

        },

        /**
         * Recebe um tempo em segundos e devolve no formato HH:MM
         * Método temporário: deve-se registrar a localização da máquina nos eventos.
         * **/
        getTimeFromSecondsMinusThreeHoursMixin(val, timezone = null) {
            if (!val || val <= 0) {
                return "";
            }
            // Quando a timezone da organização é informada, formata a hora no fuso da org.
            if (timezone) {
                return moment(val * 1000).tz(timezone).format('HH:mm');
            }
            // Comportamento legado (usado por outras telas): subtrai 3h fixas (UTC-3).
            const THREE_HOURS_IN_SECONDS = 10800;
            val = val - THREE_HOURS_IN_SECONDS;
            return new Date(val * 1000).toISOString().substr(11, 5)

        },

        getTimeFromSecondsDurationFormatMixin(val) {
            if (!val || val <= 0) {
                return "";
            }

            return formatSecondsAsHours(val);
        },

        getMinutesFromSecondsDurationFormatMixin(val) {
            if (!val || val <= 0) {
                return "";
            }

            var minutes = Math.floor(val / 60);

            if (minutes <= 0) {
                return "0m";
            }

            return minutes + "m";
        },

        getTimeFromSecondsDurationFormatMixinShowZero(val) {
            if (val === null || val === undefined || val < 0) {
                return "";
            }

            return formatSecondsAsHours(val);
        },

        getTimeFromHoursDurationFormatMixin(val) {
            if (!val || val <= 0) {
                return formatHours(0);
            }

            return formatHours(val);
        },
        getTimeFromSecondsDurationExcelFormatMixin(val) {
            if (!val || val <= 0) {
                return "";
            }

            var sec_num = parseInt(val, 10);
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            hours = hours < 10 ? "0" + hours: hours;
            minutes = minutes < 10 ? "0" + minutes: minutes;
            seconds = seconds < 10 ? "0" + seconds: seconds;

            if (val < 60) {
                return '00:00:' + seconds;
            }
            if (val < 3600) {
                return '00:' + minutes + ':' + seconds;
            }
            return hours + ':' + minutes + ':' + seconds;
        },
    },
};
